// extracted by css-extract-rspack-plugin
export default {"icon":"home-fragment__USPSlider_icon__gZdMT"};